import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DEFAULT_CONFIG } from '../constants';
import { RestClient } from '../rest-client';
import { transformUserManageConfig } from './utils';
var defaultConfig = {
  serviceUrl: "".concat(DEFAULT_CONFIG.stargateRoot, "/users")
};
export var IdentityClient = /*#__PURE__*/function (_RestClient) {
  _inherits(IdentityClient, _RestClient);
  var _super = _createSuper(IdentityClient);
  function IdentityClient() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, IdentityClient);
    return _super.call(this, _objectSpread(_objectSpread({}, defaultConfig), config));
  }
  _createClass(IdentityClient, [{
    key: "getUserManageConfig",
    value: function () {
      var _getUserManageConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.getResourceCached("/".concat(userId, "/manage")).then(function (resp) {
                return transformUserManageConfig(resp);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getUserManageConfig(_x) {
        return _getUserManageConfig.apply(this, arguments);
      }
      return getUserManageConfig;
    }()
  }, {
    key: "getMyAvatarUploadedStatus",
    value: function () {
      var _getMyAvatarUploadedStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.getResourceCached("/".concat(userId, "/manage/avatar")));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getMyAvatarUploadedStatus(_x2) {
        return _getMyAvatarUploadedStatus.apply(this, arguments);
      }
      return getMyAvatarUploadedStatus;
    }()
  }]);
  return IdentityClient;
}(RestClient);
export default new IdentityClient();